import React, { useEffect, useRef } from 'react';
import './VenueAnalysisGrid.scss';
import './OrderLiquidityBreakdown.scss';

import { select } from 'd3-selection';

import './VenueAnalysisTypeToVenueSankey.scss';
import { styleConstants } from './variables.module.constants';
import { drawTrapezoids, TrapezoidPath } from 'utils/d3fc/trapezoid';

interface VenueAnalysisSankeyProps {
    getData: (width: number) => TrapezoidPath[];
    height: number;
    width: number;
}

export function VenueAnalysisSankey({
    getData,
    height,
    width: containerWidth,
}: VenueAnalysisSankeyProps) {
    const sankeyRef = useRef<SVGSVGElement>(null);

    const width =
        containerWidth -
        styleConstants.labelWidth -
        styleConstants.spaceAround * 2 -
        styleConstants.layoutBorderWidth * 2 -
        styleConstants.contentHorizontalPadding * 2;

    const data = getData(width);

    useEffect(() => {
        const svg = select(sankeyRef.current);
        drawTrapezoids(svg, data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sankeyRef.current, data]);

    if (data.length === 0) {
        return <></>;
    }

    return (
        <svg className="sankey" width={width} height={height} ref={sankeyRef} />
    );
}
